import { client } from '../apiClient';
import {
  GeoReportResponse,
  GeoReportStatusResponse,
  GeoReportUsageResponse,
} from '../../models/geo-report/GeoReportResponse';

const GEO_REPORT_ENDPOINT = '/geo-report';

export const getGeoReports = async (): Promise<GeoReportResponse[]> => {
  const { data } = await client(true, true).get<GeoReportResponse[]>(GEO_REPORT_ENDPOINT);
  return data;
};

export const getGeoReport = async (id: number): Promise<GeoReportResponse> => {
  const { data } = await client(true, true).get<GeoReportResponse>(`${GEO_REPORT_ENDPOINT}/${id}`);
  return data;
};

export const getGeoReportStatus = async (id: number): Promise<GeoReportStatusResponse> => {
  const { data } = await client(true, true).get<GeoReportStatusResponse>(
    `${GEO_REPORT_ENDPOINT}/${id}/status`
  );
  return data;
};

export type GenerateGeoReportPayload = {
  url: string;
  companyScale?: 'auto' | 'solo' | 'small' | 'mid' | 'enterprise';
};

export const generateGeoReport = async (
  payload: GenerateGeoReportPayload
): Promise<GeoReportResponse> => {
  const { data } = await client(true, true).post<GeoReportResponse>(
    `${GEO_REPORT_ENDPOINT}/generate`,
    payload
  );
  return data;
};

export const getGeoReportUsage = async (): Promise<GeoReportUsageResponse> => {
  const { data } = await client(true, true).get<GeoReportUsageResponse>(
    `${GEO_REPORT_ENDPOINT}/usage`
  );
  return data;
};